module.exports = __webpack_public_path__ + "images/lab/organization-3d46012af28d3e54fc5cf82e929e570d.jpg";